import { createDefaultContext } from "@imi/ui/helpers/createDefaultContext.js";
import { createContext } from "react";

type FilterTabs = {
  open: boolean;
  setOpen: (value: boolean) => void;
};

export const FilterTabsContext = createContext<FilterTabs>(
  createDefaultContext(),
);
